<template lang="pug">
include /@ibkr/lib.common/src/icon/arrow
include /@ibkr/lib.common/src/icon/basic
include /@ibkr/lib.common/src/icon/color
ib-col
    div(v-if="status === 'loading'", class="alignment")
        ib-progress-circular(width="128px", height="128px")
    div(v-if="status === 'prodResults'")
        div(class="product-results")
            h1 {{ selectedExch }} ({{ selectedExch }})
            div(class="start-download")
                ib-button(class="dark-grey-text start", @click="downloadMapping", id="download") {{ $t('download_to_xls') }}
                ib-button(@click="startOver", class="dark-grey-text start", v-if="exchIdParam.length === 0") {{ $t('start_over') }}
        ib-tab-bar(v-model="selectedOption", class="result-tabs")
            ib-tab2(key="products", :class="{tab_style: selectedOption === 'products'}", class="tab") {{ $t('products') }}
            ib-tab2(key="order types", :class="{tab_style: selectedOption === 'order types'}", class="tab") {{ $t('order_types') }}
        div(class="view", v-if="selectedOption === 'products'")
            div(class="search")
                div(class="flex-flex")
                    ib-field(
                        v-model="searchTerm",
                        @input="checkValidation(searchTerm)"
                       :placeholder="$t('product_symbol')",
                       autofocus=true,
                       width="100%",
                       class="ticker-field"
                    )
                    span(class="bg15-inverse cancel", @click="clearField(true)")
                        +icon-basic-cancel
                    button(class="magnify", @click="submit") 
                        +icon-basic-search_filled
                div(class="options")
                    ib-button(
                        width="100%", class="mt-2",
                        :class="{ active: selectedProductType === 'all' }"
                        @click="prodType('all', '')"
                    )
                        span(class="typeValue") {{ $t('show_all') }}
                        br
                        span(
                            class="total"
                        ) {{ total }}
                    ib-button(
                        v-for="(type, index) in types",
                        :key="index",
                        width="100%", class="mt-2",
                        :class="{ active: selectedProductType === type.symbol }",
                        @click="prodType(type.symbol, '')"
                    ) 
                        span(class="typeValue") {{ $t(type.name) }}
                        p() {{ type.totalCount }}
            div(class="results")
                ProductSearchResults
        div(v-if="selectedOption === 'order types'")
            div(class="orderTypeTable")
                ib-table-basic(
                        :data="orderTypesResults",
                        row,
                        colborder,
                        rowstripe,
                        spacing="huge",
                        style="border: 1px solid rgba(0,0,0,0.15); overscroll-behavior:contain;"
                    )
                        ib-table-col(width="20ch", sticky, class="header")
                            div(class="border-bottom")
                                span(:title="$t('native_by_exchange')") {{ $t('native_by_exchange') }}
                        ib-table-col(width="45ch", sticky, class="header")
                            div(class="border-bottom")
                                span(:title="$t('simulated_by_ib')") {{ $t('simulated_by_ib') }}
                        template(slot="body", slot-scope="res")
                            td(class="description", @click="openLink(res['native'])") {{ res['native'] }}
                                span(v-if="isAssetType(res)")
                                    +icon-arrow-long_arrow_right
                                span(class="assetDescription", v-if="isAssetType(res)")  ({{ res['assetType'] }})
                            td(class="description", @click="openLink(res['simulate'])") {{ res['simulate'] }}
                                +icon-arrow-long_arrow_right
                                span(class="assetDescription")  ({{ res['assetType'] }})
                div()
                    p {{$t('order_type_footer_1')}}
    div(v-else-if="status === 'failed'")
        span(class="warnings")
            +icon-color-warning 
        span(class="warning-message") There is no data available for the requested exchange.
</template>

<script>

import { mapState, mapActions, mapGetters } from 'vuex';
import api from '../api/index.js';
import ProductSearchResults from './ProductSearchResults.vue';
import { exportCSV } from '../utils/fileUtils.js'

export default {
    Name: 'ProductResults',
    components: {
        ProductSearchResults,
    },
    data() {
        return {
            invalidInput: false,
            total: 0,
            currentSort: { type: 'symbol', dir: 'asc'},
            exchIdParam: '',
        }
    },
    mounted() {
        // Fuctionality for /exchanges/:exchId route
        if(this.$route.params.exchId){
            this.exchIdParam = this.$route.params.exchId;
            this.exchangeSearch(this.$route.params.exchId);
        }
    },
    watch: {
        '$route.params.exchId'(to, from) {
            this.exchangeSearch(to);
        },
       '$route.params.type'(to, from) {
            console.debug("type detected in product results");
        }
    },
    methods: {
        prodType(productType, searchValue) {
            if(productType === 'all'){
                this.setSelectedProductType('all');
                this.showAllProducts(searchValue)
            } else {
                this.setSelectedProductType(productType);
                if(this.status === 'prodResults'){
                    this.setSecDefData("");
                    let limit = this.numShow.split(' ')[1];
                    if (!limit) limit = 100;
                    this.setPageNumber(1);
                    let type = [];
                    type.push(this.selectedProductType);
                    this.typesList.map(val => {
                        if(val.productType === this.selectedProductType){
                            this.setTotalPages(val.totalCount);
                        }
                    })
                    const options = {
                        pageSize: limit,
                        pageNumber: this.pageNumber,
                        sortField: this.currentSort.type,
                        sortDirection: this.currentSort.dir,
                        domain: this.selectedDomain,
                    };

                    if(searchValue){
                        options.productSymbol = searchValue.toUpperCase();
                    } else {
                        this.searchTerm = '';
                    }

                    this.setApiStatus('wait');
                    api.getProductsByExchangeAndType(this.selectedExch, type, options)
                        .then((response) => {
                            if(response.products.length === 0){
                                $alert('No results found');
                                this.setApiStatus('results');
                            } else {
                                const filteredResponse = response.products.filter(res => res.type === this.selectedProductType).map(res => res);
                                if(!searchValue){
                                    this.setProductResults(filteredResponse);
                                }
                                this.setSearchResults(filteredResponse);
                                if(this.typesList.includes('BOND')){
                                    this.productDetails();
                                }
                                this.setApiStatus('results');
                                this.setTotalPages(response.productCount);
                                console.debug("total pages", this.totalPages);
                            }
                        })
                }
            }

        },
        assetType(asset) {
            switch(asset) {
                case 'ETF':
                    return 'ETFs';
                    break;
                case 'IND':
                    return 'Indices';
                    break;
                case 'STK':
                    return 'Stocks';
                    break;
                case 'IOPT':
                    return 'Structured Products';
                    break;
                case 'BOND':
                    return 'Bonds';
                    break;
                case 'OPT':
                    return 'Options';
                    break;
                case 'WAR':
                    return 'Warrants';
                    break;
                case 'CRYPTO':
                    return 'Crypto';
                    break;
                case 'CASH':
                    return 'CASH';
                    break;
                case 'CMDTY':
                    return 'CMDTY';
                    break;
                case 'FOP':
                    return 'FOP';
                    break;
                case 'FUND':
                    return 'FUND';
                    break;
                case 'FUT':
                    return 'Futures';
                    break;
                case 'CFD':
                    return 'CFD';
                    break;
            }
        },
        openLink(link) {
            let url = this.orderTypes.filter(ot => ot.type === link).map(ot => ot.url);
            if(url.length){
                window.open(url[0],"_blank");
            }
        },
        isAssetType(val){
            if(val['native'].length){
                return true;
            } else {
                return false;
            }
        },
        startOver() {
            this.total = 0;
            this.reset();

            const notes = document.querySelector('.notes');
            const mfundDisclosure = document.querySelector('.mutual-fund-disclosure');
            const etfDisclosure = document.querySelector('.etf-disclosure');
            const cryptocurrencyUsDisclosure = document.querySelector('.cryptocurrency-disclosure');
            const exchangeSpecificDisclosure = document.querySelector('.exchange-specific-disclosure');
            const usDisclosure = document.querySelector('.us-disclosure');
            const nonUsDisclosure = document.querySelector('.non-us-disclosure');
            const usDisclosureNotes = document.querySelectorAll('.us-disclosure-notes');
            const nonUsDisclosureNotes = document.querySelectorAll('.non-us-disclosure-notes');
            const disclosureText = document.querySelector('.disclosure-text');
            for(let i = 0; i < usDisclosureNotes.length; i++){
                usDisclosureNotes[i].style.display = "none";
            }
            for(let i = 0; i < nonUsDisclosureNotes.length; i++){
                nonUsDisclosureNotes[i].style.display = "none";
            }
            if(notes){
                notes.style.display = "none";
            }
            if(etfDisclosure){
                etfDisclosure.style.display = "none";
            }
            if(cryptocurrencyUsDisclosure){
                cryptocurrencyUsDisclosure.style.display = "none";
            }
            mfundDisclosure.style.display = "none";
            exchangeSpecificDisclosure.style.display = "none";
            usDisclosure.style.display = "none";
            nonUsDisclosure.style.display = "none";
            disclosureText.style.display = "none";
            
            const cfdDisclosure = document.querySelector('#retail-investors');
            cfdDisclosure.style.display = "none";
        },
        downloadMapping() { 
            const header = ['SYMBOL', 'DESCRIPTION', 'IBKR SYMBOL', 'CURRENCY', 'PRODUCT', 'REGION', 'EXCHANGE']
            const fields = ['symbol', 'description', 'localSymbol', 'currency', 'type', 'country', 'exchangeId']
            exportCSV(header, fields, this.searchResults, this.secDefData, ',', 'Search Results');
        },
        checkValidation(val) {
            console.log("Validating user input...");
            this.setPageNumber(1);
            this.invalidInput = /[^a-zA-Z-,\d\s:.&']/g.test(val) ? true : false;
            if (this.invalidInput) {
                this.clearField(true);
                this.setPreventSearch(true);
                this.$alert("Input a valid exchange or product name");
            } else {
                this.setPreventSearch(false);
            }
        },
        clearField(bool){
            Vue.nextTick(() => {
                this.searchTerm = '';
            });
            console.debug("selected product type", this.selectedProductType, this.typesList);

            this.prodType(this.selectedProductType, '');
        },
        submit(){
            console.debug('Searching for Ids');

            // Filering results based on user search
            this.prodType(this.selectedProductType, this.searchTerm);
        },
        showAllProducts(searchValue) {
            let limit = this.numShow.split(' ')[1];
            if (!limit) limit = 100;
            let options = {
                pageNumber: this.pageNumber,
                pageSize: limit,
                sortField: this.currentSort.type,
                sortDirection: this.currentSort.dir,
                domain: this.selectedDomain,
            }
            if(searchValue){
                options.productSymbol = searchValue.toUpperCase();
            } else {
                this.searchTerm = '';
            }
            this.setApiStatus('wait');
            api.getProductsByExchange(this.selectedExch, options)
                .then(response => {
                    if(response.products.length === 0){
                        $alert('No results found');
                        this.setApiStatus('results');
                    } else {
                        this.setProducts(response.products);
                        
                        // Populating the results table with pre selected product type
                        const filteredResponse = response.products;
                        
                        this.setTotalPages(response.productCount);
                        
                        // Filter results based on restriction for various products types
                        let restrictedProducts = this.restrictedProducts.map(product => product.symbol);
                        let results = [];
                        for(let i=0; i<this.products.length; i++){
                            if(this.selectedDomain === 'jp'){
                                if(!restrictedProducts.includes(this.products[i].symbol)){
                                    results.push(this.products[i]);
                                } else {
                                    console.debug("restricted product: ", this.products[i].symbol);
                                }
                            } else if(this.products[i].type === 'CRYPTO') {
                                if(this.allowedCryptoProducts.includes(this.products[i].symbol)){
                                    results.push(this.products[i]);
                                }
                            } else {
                                results.push(this.products[i]);
                            }
                        }

                        if(!this.searchTerm){
                            this.setProductResults(filteredResponse);
                        }
                        this.setSearchResults(filteredResponse);
                        // Funcitonality to show/hide 250, 500 options in Show Rows dropdown
                        if(this.searchResults.length < 100){
                            this.setResultStatus(false);
                        } else {
                            this.setResultStatus(true);
                        }
                        // Updated status flag to display results
                        this.setApiStatus('results');
                    }
                })
                .catch(error => console.error(error))
        },
        exchangeSearch(val){
            if(!this.restrictedExchanges.includes(val.toUpperCase())){
                this.setStatus('loading');
                const options = {
                    pageNumber: 1,
                    pageSize: 100,
                    domain: this.selectedDomain
                }
                //API to fetch results using exchange ID
                api.getProductsByExchange(val,options)
                    .then(response => {
                        if(response.length === 0){
                            this.setStatus('failed');
                        } else {
                            this.setselectedExch(val.toUpperCase());
                            let pageCount = response.map(res => res['pageCount']);
                            this.setProducts(response);
                            this.setTotalPages(pageCount[0]);
                            if(this.products.length){
                                const types = this.products.map(res => res.type);
                                const uniqueTypes = [... new Set(types)];
                                this.setTypesList(uniqueTypes);
                                this.setSelectedProductType(uniqueTypes[0]);
                                const filteredResponse = response.filter(res => res.type === uniqueTypes[0]).map(res => res);
                                this.setProductResults(filteredResponse);
                                this.setSearchResults(filteredResponse);
                            }
                            this.setStatus('prodResults');
                        }
                    })
                api.getOrderTypesByExchange(val)
                    .then(response => {
                        let natives = response.natives;
                        let simulated = response.simulated;
                        let assetTypes = response.assetType;
                        let appendCount = simulated.length - natives.length;
                        for(let i=0; i < appendCount ; i++) {
                            natives.push("");
                        }
                        let orderTypesData = [];
                        let nativeSize = natives.length;
                        let assetTypeSize = assetTypes.length;
                        for(let i = 0; i < simulated.length; i++){
                            let temp = {};
                            if(nativeSize != 0){
                                temp.native = natives[i];
                                nativeSize--;
                            }
                            temp.simulate = simulated[i];
                            temp.assetType = assetTypes.toString().toLowerCase();
                            orderTypesData.push(temp);
                        }
                        this.setOrderTypesResults(orderTypesData);
                    })
            } else {
                this.setselectedExch("");
            }
            
        },
        ...mapActions(['setDefaultOption', 'setSelectedProductType', 'setProductResults', 'reset', 'setSearchResults',
                    'setProducts', 'setTotalPages', 'setTypesList', 'setSelectedProductType', 'setProductResults',
                    'setSearchResults', 'setselectedExch', 'setOrderTypesResults', 'setStatus', 'setSecDefData', 'setPageNumber', 'setSearchTerm'
                    ,'setApiStatus', 'setPreventSearch', 'setResultStatus'])
    },
    computed: {
        selectedOption: {
            get: function() {
                return this.$store.state.defaultOption;
            },
            set: function(newValue) {
                this.setDefaultOption(newValue);
            }
        },
        types: function() {
            this.typesList.forEach(type => {
                this.total += type.totalCount;
            })
            return this.typesList;
        },
        searchTerm: {
            get: function(){
                return this.$store.state.searchTerm;
            },
            set: function(newValue){
                this.setSearchTerm(newValue);
            }
        },
        ...mapGetters(['selectedDomain']),
        ...mapState(['selectedProductType', 'products', 'selectedExch', 'orderTypesResults', 'typesList', 
                'orderTypes', 'productResults', 'searchResults', 'secDefData', 'status', 'numShow', 'totalPages', 'restrictedProducts', 'pageNumber', 'resultStatus'])
    },
}
</script>
 
<style lang="less" scoped>
.cancel {
    display: inline-block;
    padding: 4px;
    border: 1px solid #d7d7d7;
    border-radius: 0;
    svg {
        color: #dcdcde;
    }
}
.magnify {
    height: 31px;
    margin: 0;
    border: 1px solid #D7D7D7;
    border-radius: 0;
    background-color: #F7F7F7;
    position: relative;
    top: 2px;
    svg {
        width: 2em;
        height: 1em;
    }
}
.ticker-field {
    margin-right: 0;
    &:hover {
        border-color: #000;
    }
}
.header {
    background-color: white;
}
.view {
    display: flex;
}
.search { 
    display: flex;
    flex-direction: column;
    width: 20%;
    padding-top: 10px;
}
.results {
    display: flex;
    flex-direction: column;
    width: 80%;
    padding: 10px 0px 0px 20px;
}
span {
    .up {
        position: relative;
        right: -8px;
        top: -6px;
        &.active-sort {
            color: #000;
        }
    }
    .down {
        position: relative;
        left: -5px;
        top: 4px;
        &.active-sort {
            color: #000;
        }
    }
}
.description {
    color: red;
    cursor: pointer;
}
.assetDescription{
    color: #333333;
}
.external-icon {
    svg {
        position: relative;
        top: 0.8px;
        left: 6px;
        width: 1em;
        height: 1em;
    }
}
.active {
    background-color: #FFFFFF !important;
    //color: red;
    border: 2px solid red;
}
.orderTypeTable {
    padding: 20px;
}
.colorStyling {
    color: red;
    cursor: pointer;
}
.start {
    float: right;
    border-radius: 0;
}
#download {
    background-color: #D91222;
    color: #FFFFFF;
}
.tab_style {
    border-bottom-color: #D91222;
}
button {
    border-radius: 0;
}

@media (max-width: 768px) {
    .start-download {
        width: 100%;
        height: 37px;
        margin-top: 12px;
    }
    .view {
        display: block;
    }
    .search {
        width: 100%;
        padding-left: 0;
        padding-right: 0;
        padding-top: 0;
    }
    .ib-tabs-set {
        display: block;
        margin-bottom: 10px;
    }
    .results {
        width: 100%;
        padding-left: 0;
        padding-right: 0;
    }
    #download {
        width: 100%;
        margin-bottom: 10px;
    }
    #startOver {
        width: 100%;
    }
    .orderTypeTable {
        padding: 5px 0 0 0;
    }
    .options {
        button {
            margin: 0;
        }
    }
    .result-tabs {
        width: 100%;
        padding-bottom: 10px;;
    }
    .tab {
        width: 50%;
    }
}
.warnings {
    display: block;
    margin: auto;
    text-align: center;
    svg {
        width: 8%;
        height: 50%;
    }
}
.warning-message {
    padding-top: 16px;
    display: block;
    margin: auto;
    text-align: center;
    font-size: 20px
}
.alignment{
    left: 50%;
}
</style>